import { render, staticRenderFns } from "./gk_editor.vue?vue&type=template&id=e2c49c9c&scoped=true"
import script from "./gk_editor.vue?vue&type=script&lang=js"
export * from "./gk_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c49c9c",
  null
  
)

export default component.exports